/**
 * Modulo de Empresas (corporacoes).
 *
 * A empresa e o eixo de tudo: grupo pertence a uma, permissao e gravada por
 * (grupo, empresa, ferramenta), e aplicacao so fica disponivel para quem a
 * contratou. Por isso a tela de edicao tambem mostra as aplicacoes vinculadas.
 */
export const nav = {
    permissao: 'accounts.empresas:ver',
    section: 'Resources',
    title: 'Corporations',
    icon: 'domain',
    route: '/empresas',
    accordion: false,
};

export default [
    {
        path: '/empresas',
        name: '/empresas',
        component: () => import('./pages/EmpresasListPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.empresas:ver' },
    },
    {
        path: '/empresas/nova',
        name: 'empresa-nova',
        component: () => import('./pages/EmpresaPage.vue'),
        meta: { requiresAuth: true, permissao: 'accounts.empresas:criar' },
    },
    {
        path: '/empresas/editar/:id',
        name: 'empresa-editar',
        component: () => import('./pages/EmpresaPage.vue'),
        props: true,
        meta: { requiresAuth: true, permissao: 'accounts.empresas:editar' },
    },
];
